<script setup>
import TitleComponent from '@/components/TitleComponent/index.vue'
import { getbrowseListAPI } from '@/apis/user'
import { onMounted, ref } from 'vue'
import GoodsItem from './GoodsItem.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const likeList = ref([])
const reqData = ref({
    name: '',
    page: 1,
    pageSize: 20,
})
const total=ref()
const getLikeList = async () => {
    const res = await getbrowseListAPI(reqData.value)
    if (res.code == 0) {
        likeList.value = res.data.data
        total.value=res.data.total
    }
}
const loading = ref(false)
const noMore = computed(() => {
    if(likeList.value){
       if(likeList.value.length >= total.value) {
        return true;
       }else{
        return false;
       }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {

    loading.value = true
    setTimeout(async () => {
        reqData.value.page++
        const res = await getbrowseListAPI(reqData.value)
        if (res.data.data) {
            likeList.value = [...likeList.value, ...res.data.data]
            loading.value = false
        }
    }, 10)
}


const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    getLikeList()
})
</script>

<template>
     <TitleComponent :title="t('number7')" v-if="isMobile==true"></TitleComponent>
    <div class="historyPage">
        <div class="home-panel">
            <div class="header" v-if="isMobile==false">
                <h4 data-v-bcb266e0="">{{$t('number7')}}</h4>
            </div>
            <div class="cart-none" v-if="likeList.length === 0">
                <el-empty :description="t('setup11')">

                </el-empty>
            </div>
            <div class="goods-list" v-else>
                <div class="body" v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
                    <!-- 商品列表-->

                    <GoodsItem v-for="(lick, index) in likeList" :key="index" :goods="lick" />
                </div>
                <p v-if="loading" style="text-align: center;padding: 20px 0 20px 0;">Loading...</p>
                <p v-if="noMore" style="text-align: center;padding: 20px 0 20px 0;">No more</p>

            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

.historyPage {
    width: 100%;
    height: 100%;

    .home-panel {
        background-color: #fff;
        padding: 20px 20px 20px 20px;
        height: 100%;
        border-radius: 8px;


        .header {
            height: 66px;
            border-bottom: 1px solid #f5f5f5;
            padding: 18px 0;
            display: flex;
            justify-content: space-between;
            align-items: baseline;

            h4 {
                font-size: 22px;
                font-weight: 400;
            }

        }

        .goods-list {

            .body {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(210px, 0fr));
                grid-auto-rows: 325px;
                grid-gap: 0px;
            }
        }
    }
}

@media (max-width: 768px) {
    // .top {
    //     font-size: 16px;
    //     display: flex;
    //     justify-content: space-between;
    //     /* padding: 13px 0; */
    //     position: fixed;
    //     background: #fff;
    //     width: 100%;
    //     height: 45px;
    //     align-items: center;
    //     z-index: 9999;
    //     padding: 0 20px;
    // }
    .historyPage {

        min-height: 100vh;
        background-color: #ffffff;
        margin-top: 0px;
        .home-panel {
            padding: 75px 20px 0px 20px;
            height: 100%;


            .goods-list {
                .body {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(48%, 0fr));
                    grid-auto-rows: 320px;
                    grid-gap: 10px;
                }
            }
        }
    }






}
</style>